import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const Drops = () => {
  gsap.registerPlugin(ScrollTrigger);

  const container = document.querySelector('.product');
  const drop01_01 = document.querySelector('.product__drop01--01');
  const drop01_02 = document.querySelector('.product__drop01--02');
  const drop01_03 = document.querySelector('.product__drop01--03');
  const drop01_04 = document.querySelector('.product__drop01--04');
  const drop01_05 = document.querySelector('.product__drop01--05');
  const drop01_06 = document.querySelector('.product__drop01--06');

  const drop02_01 = document.querySelector('.product__drop02--01');
  const drop02_02 = document.querySelector('.product__drop02--02');
  const drop02_03 = document.querySelector('.product__drop02--03');
  const drop02_04 = document.querySelector('.product__drop02--04');
  const drop02_05 = document.querySelector('.product__drop02--05');
  const drop02_06 = document.querySelector('.product__drop02--06');
  const drop02_07 = document.querySelector('.product__drop02--07');
  const drop02_08 = document.querySelector('.product__drop02--08');

  gsap.to(drop01_01, {
    y: -200,
    scrollTrigger: {
      trigger: container,
      scrub: 5,
    },
  });

  gsap.to(drop01_02, {
    y: -220,
    scrollTrigger: {
      trigger: container,
      scrub: 4,
    },
  });

  gsap.to(drop01_03, {
    y: -400,
    scrollTrigger: {
      trigger: container,
      scrub: 7,
    },
  });

  gsap.to(drop01_04, {
    y: -200,
    scrollTrigger: {
      trigger: container,
      scrub: 1,
    },
  });

  gsap.to(drop01_05, {
    y: -200,
    scrollTrigger: {
      trigger: container,
      scrub: 3,
    },
  });

  gsap.to(drop01_06, {
    y: -200,
    scrollTrigger: {
      trigger: container,
      scrub: 8,
    },
  });

  gsap.to(drop02_01, {
    y: -150,
    scrollTrigger: {
      trigger: container,
      scrub: 3,
    },
  });

  gsap.to(drop02_02, {
    y: -400,
    scrollTrigger: {
      trigger: container,
      scrub: 5,
    },
  });

  gsap.to(drop02_03, {
    y: -200,
    scrollTrigger: {
      trigger: container,
      scrub: 3,
    },
  });

  gsap.to(drop02_04, {
    y: -500,
    scrollTrigger: {
      trigger: container,
      scrub: 6,
    },
  });

  gsap.to(drop02_05, {
    y: -200,
    scrollTrigger: {
      trigger: container,
      scrub: 8,
    },
  });

  gsap.to(drop02_06, {
    y: -600,
    scrollTrigger: {
      trigger: container,
      scrub: 4,
    },
  });

  gsap.to(drop02_07, {
    y: -300,
    scrollTrigger: {
      trigger: container,
      scrub: 8,
    },
  });

  gsap.to(drop02_08, {
    y: -260,
    scrollTrigger: {
      trigger: container,
      scrub: 3,
    },
  });
};

export default Drops;
